<div
  class="mobile-filters-shell"
  [class.filter-detail-open]="selectedColumn"
  [class.has-active-filters]="hasActiveFilters"
>
  @if (!selectedColumn) {
    <div class="mobile-filters-header">
      <div class="filter-heading-actions">
        <h2>{{ 'filters' | translate }}</h2>
        @if (hasActiveFilters) {
          <app-ui-button
            buttonType="link"
            [text]="('clearAllFilters' | translate) + ' (' + activeFilterCount + ')'"
            (click)="clearAll()"
          ></app-ui-button>
        }
      </div>
      <app-ui-button
        buttonType="icon-button"
        icon="close"
        [tooltip]="'close' | translate"
        (click)="close()"
      ></app-ui-button>
    </div>

    <div class="filter-category-list">
      @for (column of availableColumns; track column) {
        <button class="filter-category" type="button" (click)="openColumn(column)">
          <span class="filter-category-copy">
            <span class="filter-category-name">
              {{ data.columnTitlesMap[column] || (column | translate) }}
            </span>
            @if (getFilterSummaryParts(column); as summaryParts) {
              @if (summaryParts.length) {
                <span class="filter-category-summary">
                  @for (part of summaryParts; track $index; let last = $last) {
                    {{ part | translate }}{{ last ? '' : ', ' }}
                  }
                </span>
              }
            }
          </span>
          <mat-icon>chevron_right</mat-icon>
        </button>
      }
    </div>
  } @else {
    <div class="mobile-filter-detail-header">
      <app-ui-button
        buttonType="mat"
        icon="arrow_back"
        [text]="'back' | translate"
        (click)="back()"
      ></app-ui-button>
    </div>
    <div class="mobile-filter-detail-body">
      <h2 class="filter-detail-title">
        {{ data.columnTitlesMap[selectedColumn] || (selectedColumn | translate) }}
      </h2>
      <app-main-table-column-filter
        class="mobile-column-filter"
        [initialFilters]="data.columnFilters[selectedColumn] ?? []"
        [column]="selectedColumn"
        [filterConfig]="data.filterConfig"
        [hasExternalChanges]="!!pendingSort"
        [requireChangesForApply]="true"
        [sortDirection]="getSortDirection(selectedColumn)"
        [sorting]="data.sortingEnabled && !data.disabledColumnHeaders.includes(selectedColumn)"
        (filter)="applyColumn(selectedColumn, $event)"
        (sort)="selectSort($event)"
        (close)="back()"
      ></app-main-table-column-filter>
    </div>
  }
</div>
